import React, { useState, useEffect } from 'react';
import { useListColorThemeQuery, useSubmitThemeSettingsFormMutation, useUpdateColorThemeMutation } from '../../Services/SettingsAPI';
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function Index() {
    const { data } = useListColorThemeQuery();
    const [submitSettings, { isLoading: isSubmitting }] = useSubmitThemeSettingsFormMutation();
    const [updateSettings, { isLoading: isUpdating }] = useUpdateColorThemeMutation();

    const [formData, setFormData] = useState({
        primary_color: '',
        banner_bg_color: '',
        product_bg_color: '',
        heading_color: '',
        paragraph_color: '',
        text_color_one: '',
        text_color_two: '',
        main_logo: null
    });

    const colorTheme = data?.color_themes?.[0] || null;

    // Populate form fields if colorTheme exists
    useEffect(() => {
        if (colorTheme) {
            setFormData({
                primary_color: colorTheme.primary_color || '',
                banner_bg_color: colorTheme.banner_bg_color || '',
                product_bg_color: colorTheme.product_bg_color || '',
                heading_color: colorTheme.heading_color || '',
                paragraph_color: colorTheme.paragraph_color || '',
                text_color_one: colorTheme.text_color_one || '',
                text_color_two: colorTheme.text_color_two || '',
            });
        }
    }, [colorTheme]);

    // Handle Input Change (for both color picker & text inputs)
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value, // Allow free editing of text input
        }));
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        // Ensure the value is a valid hex color when the user finishes typing
        if (!/^#([0-9A-F]{3}){1,2}$/i.test(value)) {
            alert("Please enter a valid hex color (e.g., #ff0000 or #f00)");
            setFormData((prev) => ({
                ...prev,
                [name]: prev[name] || "#000000", // Revert to last valid value or default
            }));
        }
    };


    // Handle File Upload
    const handleFileChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            main_logo: e.target.files[0],
        }));
    };

    // Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (value) formDataToSend.append(key, value);
        });

        try {
            if (colorTheme) {
                // Update existing theme
                await updateSettings({ id: colorTheme.id, body: formDataToSend }).unwrap();
                alert('Settings updated successfully!');
            } else {
                // Submit new theme
                await submitSettings(formDataToSend).unwrap();
                alert('Settings submitted successfully!');
            }
        } catch (error) {
            console.error('Error submitting settings:', error);
            alert('Failed to submit settings.');
        }
    };

    return (
        <div className='general-settings'>
            <h3>General Settings</h3>
            <div className="content-wrapper">
                <form encType="multipart/form-data" onSubmit={handleSubmit}>
                    {/* Color Inputs */}
                    {[
                      { label: "Primary Color", name: "primary_color", info: "Used for buttons backgorund and main highlights" },
                      { label: "Banner Background Color", name: "banner_bg_color", info: "Background of the banner section" },
                      { label: "Product Background Color", name: "product_bg_color", info: "Background for product listings" },
                      { label: "Heading Color", name: "heading_color", info: "Used for headings and titles" },
                      { label: "Paragraph Color", name: "paragraph_color", info: "Body text color" },
                      { label: "Secondary Text Color", name: "text_color_one", info: "Used for subtitles, product category and small text" },
                    ].map((field, index) => (
                        <div className="form-group color-picker-container" key={index}>
                            <label>{field.label}:  <div className="tooltip-container">
                                <FontAwesomeIcon
                                    icon={faCircleInfo}
                                    className="text-warning mx-2"
                                    style={{ cursor: "pointer" }}
                                />
                                <div className="tooltip">{field.info}</div>
                            </div></label>

                            <div className="color-input-wrapper">
                                {/* Color Picker */}
                                {/* Color Picker */}
                                <input
                                    type="color"
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    className="color-picker"
                                />

                                <input
                                    type="text"
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    onBlur={handleBlur} // Validate on blur
                                    className="hex-input"
                                />

                            </div>
                        </div>
                    ))}

                    {/* File Upload */}
                    <div className="form-group upload-web-logo">
                        <label>Upload Logo:</label>
                        <input type="file" className="upload-logo-input" name="main_logo" onChange={handleFileChange} /><br />
                    </div>

                    <div className='logo-dimmension-style'>
                        <p className='m-0 p-0'>(* Minimum dimensions: 100x50 pixels)</p>
                        <p>(* Maximum dimensions: 200x100 pixels.)</p>
                    </div>

                    {/* Display Uploaded Logo */}
                    <div>
                        {colorTheme?.main_logo_url && <img src={colorTheme?.main_logo_url} alt="img" className='uploaded-logo' />}
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="btn-primary mt-4" disabled={isSubmitting || isUpdating}>
                        {isSubmitting || isUpdating ? "Processing..." : colorTheme ? "Update" : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Index;
